import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import svCommon from './locales/sv/common.json';
import svLanding from './locales/sv/landing.json';
import svFooter from './locales/sv/footer.json';
import svAdvertiser from './locales/sv/advertiser.json';
import svMetadata from './locales/sv/metadata.json';
import svMenu from './locales/sv/menu.json';
import svFaq from './locales/sv/faq.json';
import svTerms from './locales/sv/terms.json';
import svInvoicery from './locales/sv/invoicery.json';
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enFooter from './locales/en/footer.json';
import enAdvertiser from './locales/en/advertiser.json';
import enMetadata from './locales/en/metadata.json';
import enMenu from './locales/en/menu.json';
import enFaq from './locales/en/faq.json';
import enTerms from './locales/en/terms.json';
import enInvoicery from './locales/en/invoicery.json';
import dkCommon from './locales/dk/common.json';
import dkLanding from './locales/dk/landing.json';
import dkFooter from './locales/dk/footer.json';
import dkAdvertiser from './locales/dk/advertiser.json';
import dkMetadata from './locales/dk/metadata.json';
import dkMenu from './locales/dk/menu.json';
import dkFaq from './locales/dk/faq.json';
import dkTerms from './locales/dk/terms.json';
import dkInvoicery from './locales/dk/invoicery.json';
import noCommon from './locales/no/common.json';
import noLanding from './locales/no/landing.json';
import noFooter from './locales/no/footer.json';
import noAdvertiser from './locales/no/advertiser.json';
import noMetadata from './locales/no/metadata.json';
import noMenu from './locales/no/menu.json';
import noFaq from './locales/no/faq.json';
import noTerms from './locales/no/terms.json';
import noInvoicery from './locales/no/invoicery.json';

export const resources = {
  sv: {
    faq: svFaq,
    common: svCommon,
    landing: svLanding,
    footer: svFooter,
    advertiser: svAdvertiser,
    metadata: svMetadata,
    menu: svMenu,
    terms: svTerms,
    invoicery: svInvoicery,
  },
  dk: {
    faq: dkFaq,
    common: dkCommon,
    landing: dkLanding,
    footer: dkFooter,
    advertiser: dkAdvertiser,
    metadata: dkMetadata,
    menu: dkMenu,
    terms: dkTerms,
    invoicery: dkInvoicery,
  },
  no: {
    faq: noFaq,
    common: noCommon,
    landing: noLanding,
    footer: noFooter,
    advertiser: noAdvertiser,
    metadata: noMetadata,
    menu: noMenu,
    terms: noTerms,
    invoicery: noInvoicery,
  },
  en: {
    faq: enFaq,
    common: enCommon,
    landing: enLanding,
    footer: enFooter,
    advertiser: enAdvertiser,
    metadata: enMetadata,
    menu: enMenu,
    terms: enTerms,
    invoicery: enInvoicery,
  },
};

const options = {
  fallbackLng: 'sv',
  supportedLngs: ['sv', 'dk', 'no', 'en'],
  preload: ['sv'],
  ns: ['common', 'landing'],
  defaultNS: 'landing',
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['path', 'cookie'],
    lookupCookie: 'language',
    lookupFromPathIndex: 0,
    caches: ['cookie'],
  },
  debug: process.env.NODE_ENV === 'development',
  resources,
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  wait: process && !process.release,
};

// for all options read: https://www.i18next.com/overview/configuration-options
i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init(options);

export default i18n;
